import React from 'react';
import { fetchBrandingInfo } from '../services/branding';
import { useEffect, useState } from 'react';

export const useBranding = (accessToken, shouldUseBranding) => {
  const [isBrandingLoading, setBrandingLoading] = useState(false);
  const [brandingInfo, setBrandingInfo] = useState(null);

  useEffect(
    () => {
      if (accessToken && shouldUseBranding) {
        setBrandingLoading(true);
        fetchBrandingInfo(accessToken)
          .then(branding => {
            setBrandingLoading(false);
            setBrandingInfo(branding);
          })
          .catch(reason => {
            setBrandingLoading(false);
            setBrandingInfo(null);
          });
      }
    },
    [accessToken, shouldUseBranding]
  );

  return { isBrandingLoading, brandingInfo };
};
